// extracted by mini-css-extract-plugin
module.exports = {"newsCategory":"NewsCategory_newsCategory__2xQI0","active":"NewsCategory_active__1Q1vM"};